import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginModalModule } from '../login-modal/login-modal.module';
import { LoginStandaloneComponent } from './login-standalone.component';

@NgModule({
  declarations: [LoginStandaloneComponent],
  imports: [CommonModule, LoginModalModule],
  exports: [LoginStandaloneComponent]
})
export class LoginStandaloneModule {}
